import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert, Container } from 'react-bootstrap'
import authServices from 'services/authServices'
import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import { getReturnUrl } from 'utils/authHelpers'
import { CookieType } from 'constants/enums/cookieTypes'

const UKAuthentication = () => {
	const { t } = useTranslation()
	const [error, setError] = useState<string | null>(null)

	async function login(applicationId: string, token: string) {
		try {
			const { secret: authSecret, returnUrl } =
				await authServices.ukAuthenticate(applicationId, token, t)
			authServices.redirectTo(returnUrl || getReturnUrl(), authSecret)
		} catch (e) {
			setError(t('AuthenticationError'))
		}
	}

	useEffect(() => {
		const storedUrl = sessionStorage.getItem(CookieType.RedirectUrl) ?? ''
		const searchParams = new URLSearchParams(storedUrl.split('?')[1] ?? '')
		const applicationId = searchParams.get('applicationid')
		const token = searchParams.get('token')

		if (applicationId && token) {
			sessionStorage.setItem(CookieType.UkToken, token)

			const cleanUrl =
				storedUrl.split('?')[0] + `?applicationid=${applicationId}`
			sessionStorage.setItem(CookieType.RedirectUrl, cleanUrl)
			window.history.replaceState(null, '', cleanUrl)

			login(applicationId, token)
		} else {
			setError(t('AuthenticationError'))
		}
		// eslint-disable-next-line
	}, [])

	return (
		<Container className="spinner-container d-flex justify-content-center align-items-center">
			{error ? (
				<Alert variant="danger">{error}</Alert>
			) : (
				<div className="col-spinner">
					<CircleSpinner />
				</div>
			)}
		</Container>
	)
}

export default UKAuthentication
